const heroVideo = (() => {

    const initBlock = (el) => {
        window.onload = () => handleVideoLoad(el);
        handlePlayPause(el);
    };

    const handleVideoLoad = (el) => {
        const video = el.querySelector('video');
        const videoSrc = video.dataset.videoSrc;
        
        const extension = (/[.]/.exec(videoSrc)) ? /[^.]+$/.exec(videoSrc) : 'mp4';

        const source = document.createElement('source');
        source.src = videoSrc;
        source.type = `video/${extension}`;

        video.appendChild(source);
    }
    
    const handlePlayPause = (el) => {
        const video = el.querySelector('video');
        const button = el.querySelector('button');
        if (video && button){
            const pauseIcon = button.querySelector('[data-icon-pause]');
            const playIcon = button.querySelector('[data-icon-play]');
            button.addEventListener('click', () => {
                if (video.paused){
                    video.play();
                    pauseIcon.classList.remove('hidden');
                    playIcon.classList.add('hidden');
                    button.setAttribute('aria-label', 'Pause');
                }else{
                    video.pause();
                    pauseIcon.classList.add('hidden');
                    playIcon.classList.remove('hidden');
                    button.setAttribute('aria-label', 'Play');
                }
            });
        }
    }

    return {initBlock};
})();

document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('[data-hero-video]').forEach(item => heroVideo.initBlock(item));
});